import React from 'react'
import { Icon, Table } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { AppState } from '../../redux/store'
import { AbbreviatedProductContainer } from '../../consts'

const BulkEditResults = (props: { productsQueue: AbbreviatedProductContainer }) => {
  const { bulkEditSuccesses, bulkEditErrors } = useSelector((state: AppState) => state.ui) // as submissions for each product complete, bulkEditSuccesses and bulkEditErrors both are arrays of product IDs
  // so a product ID 123 in bulkEditSuccesses means that product 123 was successfully updated
  const { productsQueue } = props

  return (
    <>
      <h2>Results</h2>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Brand</Table.HeaderCell>
            <Table.HeaderCell>Success?</Table.HeaderCell>
            <Table.HeaderCell>Error Msg</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {bulkEditErrors.map(({ id, message }: { id: number; message: string }) => (
            <Table.Row error>
              <Table.Cell>{id}</Table.Cell>
              <Table.Cell>{productsQueue[id]?.name}</Table.Cell>
              <Table.Cell>{productsQueue[id]?.brand}</Table.Cell>
              <Table.Cell>
                <Icon name="x" />
              </Table.Cell>
              <Table.Cell>{message || 'Unspecified error'}</Table.Cell>
            </Table.Row>
          ))}
          {bulkEditSuccesses.map((id: number) => (
            <Table.Row positive>
              <Table.Cell>{id}</Table.Cell>
              <Table.Cell>{productsQueue[id]?.name}</Table.Cell>
              <Table.Cell>{productsQueue[id]?.brand}</Table.Cell>
              <Table.Cell>
                <Icon name="checkmark" />
              </Table.Cell>
              <Table.Cell>N/A</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  )
}

export default BulkEditResults
